export class MessagesModel {
    Sid: string;
    From: string;
    To: string;
    Body: string;
    Status: string;
    DateSent: string;
    first_name: string;
    client_no: number;

    constructor(
        Sid: string,
        From: string,
        To: string,
        Body: string,
        Status: string,
        DateSent: string,
        first_name: string,
        client_no: number
    ) {
        this.Sid = Sid;
        this.From = From;
        this.To = To;
        this.Body = Body;
        this.Status = Status;
        this.DateSent = DateSent;
        this.first_name = first_name;
        this.client_no = client_no;
    }
}

export class DistinctContactsModel {
    mTo: string;
    mDateCreated: string;
    first_name: string;
    client_no: number;

    constructor(
        mTo: string, 
        mDateCreated: string, 
        first_name: string, 
        client_no: number
    ) {
        this.mTo = mTo;
        this.mDateCreated = mDateCreated;
        this.first_name = first_name;
        this.client_no = client_no;
    }
}